document.addEventListener('DOMContentLoaded', () => {
    // Find the button
    const gatoButton = document.getElementById('gatoButton0001');

    if (gatoButton) {
        // Add a click event listener
        gatoButton.addEventListener('click', () => {
            const ingredientsKey = 'order_note_selected_ingredients';
            const currentValue = localStorage.getItem(ingredientsKey);

            // Check if the value is missing or blank
            if (currentValue === null || currentValue === '') {
                // Set the default value
                localStorage.setItem(ingredientsKey, 'Pollo,Carne,Pernil');
                console.log('Default ingredients set on button click: Pollo,Carne,Pernil');
            } else {
                console.log('Ingredients already exist, not overwriting.');
            }
        });
    } else {
        console.error('Error: Button with ID "gatoButton0001" not found.');
    }
});



document.addEventListener('DOMContentLoaded', () => {
    // Target each checkbox directly by its unique ID
    const polloCheckbox = document.getElementById('ingredient-pollox');
    const carneCheckbox = document.getElementById('ingredient-carnex');
    const pernilCheckbox = document.getElementById('ingredient-pernilx');

    // Collect them into an array. Filter out any null values in case an element isn't found.
    const allIngredientCheckboxes = [polloCheckbox, carneCheckbox, pernilCheckbox].filter(Boolean);

    const displayArea = document.querySelector('.food-ingredients-cat');
    const localStorageKey = 'order_note_selected_ingredients';

    // Ensure the display area exists before proceeding
    if (!displayArea) {
        console.warn("Element with class 'food-ingredients-cat' not found. Selected ingredients will not be displayed.");
    }

    /**
     * Updates the displayed ingredients and saves the current selection to local storage.
     */
    function updateSelectedIngredients() {
        const selectedIngredients = [];
        allIngredientCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                selectedIngredients.push(checkbox.value);
            }
        });

        // Update the display area if it exists
        if (displayArea) {
            if (selectedIngredients.length > 0) {
                displayArea.textContent = selectedIngredients.join(', '); // Display as comma-separated
            } else {
                displayArea.textContent = 'No ingredients selected.';
            }
        }

        // --- KEY CHANGE FOR SAVING ---
        // Save the selected ingredients as a simple comma-separated string
        localStorage.setItem(localStorageKey, selectedIngredients.join(','));
    }

    // Load saved selections from local storage when the page loads
    const savedIngredientsString = localStorage.getItem(localStorageKey);
    if (savedIngredientsString) {
        // --- KEY CHANGE FOR LOADING ---
        // Split the string back into an array for checking checkbox states
        const parsedIngredients = savedIngredientsString.split(',').filter(item => item.trim() !== ''); // Filter out empty strings if any

        allIngredientCheckboxes.forEach(checkbox => {
            if (checkbox) {
                if (parsedIngredients.includes(checkbox.value)) {
                    checkbox.checked = true;
                } else {
                    checkbox.checked = false; // Uncheck if it's not in the saved list
                }
            }
        });
    }

    // Attach the change event listener to each checkbox
    allIngredientCheckboxes.forEach(checkbox => {
        if (checkbox) {
            checkbox.addEventListener('change', updateSelectedIngredients);
        }
    });

    // Run the update function once initially when the page loads.
    // This will read the initial 'checked' state (either from HTML or restored from local storage above),
    // save it to local storage as the desired string format, and display it.
    updateSelectedIngredients();
});









document.addEventListener('DOMContentLoaded', () => {

    // =======================================================
    // Ingredient Selection Logic
    // =======================================================

    const polloCheckbox = document.getElementById('ingredient-pollox');
    const carneCheckbox = document.getElementById('ingredient-carnex');
    const pernilCheckbox = document.getElementById('ingredient-pernilx');

    const allIngredientCheckboxes = [polloCheckbox, carneCheckbox, pernilCheckbox].filter(Boolean);

    const displayArea = document.querySelector('.food-ingredients-cat');
    const localStorageIngredientsKey = 'order_note_selected_ingredients'; // Corrected key name for clarity and consistency

    if (!displayArea) {
        console.warn("Element with class 'food-ingredients-cat' not found. Selected ingredients will not be displayed.");
    }

    function updateSelectedIngredients() {
        const selectedIngredients = [];
        allIngredientCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                selectedIngredients.push(checkbox.value);
            }
        });

        if (displayArea) {
            if (selectedIngredients.length > 0) {
                displayArea.textContent = 'RECETAS DE ' + selectedIngredients.join(', ');
            } else {
                displayArea.textContent = 'No ingredients selected.';
            }
        }

        // Save selected ingredients to localStorage
        localStorage.setItem(localStorageIngredientsKey, selectedIngredients.join(','));
    }

    // Load saved ingredients on page load
    const savedIngredientsString = localStorage.getItem(localStorageIngredientsKey);
    if (savedIngredientsString) {
        const parsedIngredients = savedIngredientsString.split(',').filter(item => item.trim() !== '');

        allIngredientCheckboxes.forEach(checkbox => {
            if (checkbox) {
                if (parsedIngredients.includes(checkbox.value)) {
                    checkbox.checked = true;
                } else {
                    checkbox.checked = false;
                }
            }
        });
    }

    // Attach event listeners for ingredient changes
    allIngredientCheckboxes.forEach(checkbox => {
        if (checkbox) {
            checkbox.addEventListener('change', updateSelectedIngredients);
        }
    });

    // Initial run for ingredients display
    updateSelectedIngredients();


    // =======================================================
    // Quantity, Frequency, and Price Calculation Logic
    // =======================================================

    // --- Elements for Quantity and Price ---
    const minusButton = document.querySelector('.minus-quantityx');
    const plusButton = document.querySelector('.plus-quantityx');
    const gramosValueDisplay = document.querySelector('.cat-gramos-value');
    const pricePerDayRegularDisplay = document.querySelector('.price-per-day-cat');
    const pricePerDayDiscountedDisplay = document.querySelector('.price-per-day-discounted-cat');
    const subtotalProductPriceFixedDisplay = document.querySelector('.product-price-fixed-cat');
    const bagsToSendDisplay = document.querySelector('.bagsToSend-cat');

    let currentGrams = 200; // Starting grams
    const gramIncrement = 25; // Increments by 50 grams
    const minGrams = 50; // Minimum allowed grams

    // Constants for the base pricing calculation
    const priceFactorNumerator = 7;
    const priceFactorDenominator = 200;



    
   let intermediateMultiplier = 0; // initialize to 0 until we fetch price

// Fetch product variant price dynamically
fetch('/products/testing.js')
  .then(response => response.json())
  .then(product => {
      const variantId = 45902440005880; // your variant ID
      const variant = product.variants.find(v => v.id == variantId);
      if (variant) {
          intermediateMultiplier = variant.price / 100; // convert cents to dollars
          console.log('Fetched variant price:', intermediateMultiplier);

          // Now that we have the price, calculate and display
          calculateAndDisplayPrice();
      } else {
          console.error('Variant not found');
      }
  })
  .catch(err => console.error('Error fetching product price:', err));



    






    // --- Elements for Frequency Selector ---
    const frequencyArrowLeft = document.querySelector('.frequency-arrow-leftx');
    const frequencyArrowRight = document.querySelector('.frequency-arrow-rightx');
    const frequencyOptionDisplay = document.querySelector('.cat-frequency-option');
    const deliveryFrequencyDisplay = document.querySelector('.delivery-frequency-cat');

    // Define the frequency options
    const frequencyOptions = [
        { name: '1 Semana', multiplier: 1 }, { name: '2 Semanas', multiplier: 2 },
        { name: '3 Semanas', multiplier: 3 }, { name: '4 Semanas', multiplier: 4 },
        { name: '5 Semanas', multiplier: 5 }, { name: '6 Semanas', multiplier: 6 },
        { name: '7 Semanas', multiplier: 7 }, { name: '8 Semanas', multiplier: 8 },
        { name: '9 Semanas', multiplier: 9 }, { name: '10 Semanas', multiplier: 10 },
        { name: '11 Semanas', multiplier: 11 }, { name: '12 Semanas', multiplier: 12 }
    ];
    let currentFrequencyIndex = 3; // Start with '4 Semana'

    // Key for saving total bags to localStorage
    const localStorageBagsKey = 'bags_to_send';

    /**
     * Updates all relevant displayed values and performs price and quantity calculations.
     */
    function calculateAndDisplayPrice() {
        // --- Quantity-based calculation ---
        const rawQuantityFactor = (currentGrams * priceFactorNumerator) / priceFactorDenominator;
        const intermediatePriceY = rawQuantityFactor * intermediateMultiplier;

        // --- Frequency-based values ---
        const currentFrequencyName = frequencyOptions[currentFrequencyIndex].name;
        const currentFrequencyMultiplier = frequencyOptions[currentFrequencyIndex].multiplier;

        // --- Calculate Bags to Send (Rounded) ---
        const totalBagsRaw = rawQuantityFactor * currentFrequencyMultiplier;
        const finalBagsToSend = Math.ceil(totalBagsRaw); // Only round up the final bag amount here

        // *** CRITICAL ADDITION: Save finalBagsToSend to localStorage ***
        localStorage.setItem(localStorageBagsKey, finalBagsToSend.toString());

        // --- Calculate Subtotal Price ---
        const newSubtotalPrice = finalBagsToSend * intermediateMultiplier;


        // --- Update Grams Display ---
        if (gramosValueDisplay) {
            gramosValueDisplay.textContent = `${currentGrams}g`;
        } else {
            console.warn("Element with class 'cat-gramos-value' not found.");
        }

        // --- Update Frequency Displays ---
        if (frequencyOptionDisplay) {
            frequencyOptionDisplay.textContent = currentFrequencyName;
        } else {
            console.warn("Element with class 'cat-frequency-option' not found.");
        }
        if (deliveryFrequencyDisplay) {
            deliveryFrequencyDisplay.textContent = currentFrequencyName;
        } else {
            console.warn("Element with class 'delivery-frequency-cat' not found.");
        }

        // --- Update Bags to Send Display ---
        if (bagsToSendDisplay) {
            bagsToSendDisplay.textContent = finalBagsToSend;
        } else {
            console.warn("Element with class 'bagsToSend-cat' not found.");
        }

        // --- Update Price Displays ---
        const formattedIntermediatePrice = intermediatePriceY.toFixed(2);
        if (pricePerDayRegularDisplay) {
            pricePerDayRegularDisplay.textContent = formattedIntermediatePrice;
        } else {
            console.warn("Element with class 'price-per-day-cat' not found.");
        }
        if (pricePerDayDiscountedDisplay) {
            pricePerDayDiscountedDisplay.textContent = formattedIntermediatePrice;
        } else {
            console.warn("Element with class 'price-per-day-discounted-cat' not found.");
        }
        if (subtotalProductPriceFixedDisplay) {
            subtotalProductPriceFixedDisplay.textContent = newSubtotalPrice.toFixed(2);
        } else {
            console.warn("Element with class 'product-price-fixed-cat' not found.");
        }
    }

    // --- Event Listeners for Quantity Buttons ---
    if (minusButton) {
        minusButton.addEventListener('click', () => {
            if (currentGrams > minGrams) {
                currentGrams -= gramIncrement;
                calculateAndDisplayPrice();
            }
        });
    } else {
        console.warn("Element with class 'minus-quantityx' not found.");
    }

    if (plusButton) {
        plusButton.addEventListener('click', () => {
            currentGrams += gramIncrement;
            calculateAndDisplayPrice();
        });
    } else {
        console.warn("Element with class 'plus-quantityx' not found.");
    }

    // --- Event Listeners for Frequency Arrows ---
    if (frequencyArrowLeft) {
        frequencyArrowLeft.addEventListener('click', () => {
            currentFrequencyIndex = (currentFrequencyIndex - 1 + frequencyOptions.length) % frequencyOptions.length;
            calculateAndDisplayPrice();
        });
    } else {
        console.warn("Element with class 'frequency-arrow-leftx' not found.");
    }

    if (frequencyArrowRight) {
        frequencyArrowRight.addEventListener('click', () => {
            currentFrequencyIndex = (currentFrequencyIndex + 1) % frequencyOptions.length;
            calculateAndDisplayPrice();
        });
    } else {
        console.warn("Element with class 'frequency-arrow-rightx' not found.");
    }

    // Initial calculation and display when the page loads
    calculateAndDisplayPrice();
});










document.addEventListener('DOMContentLoaded', () => {

    const confirmButtonContainer = document.querySelector('.atcx-button'); // The container holding the button
    const localStorageBagsKey = 'bags_to_send'; // Key to retrieve total bags
    const localStorageIngredientsKey = 'order_note_selected_ingredients'; // Key for selected ingredients

    if (!confirmButtonContainer) {
        console.warn("Element with class 'atcx-button' not found. Confirm button functionality will not work.");
        return; // Exit if the button isn't found
    }

    confirmButtonContainer.addEventListener('click', () => {
        console.log("Confirm button clicked. Initiating product distribution...");

        // 1. Retrieve saved data
        const totalBagsString = localStorage.getItem(localStorageBagsKey);
        const selectedIngredientsString = localStorage.getItem(localStorageIngredientsKey);

        const totalBags = totalBagsString ? parseInt(totalBagsString, 10) : 0;
        const selectedIngredients = selectedIngredientsString ? selectedIngredientsString.split(',').filter(item => item.trim() !== '') : [];

        if (totalBags === 0) {
            console.warn("No total bags value found or bags are 0 in localStorage. Distribution cannot be performed.");
            return;
        }
        if (selectedIngredients.length === 0) {
            console.warn("No ingredients selected in localStorage. Distribution cannot be performed.");
            return;
        }

        console.log(`Total Bags: ${totalBags}`);
        console.log(`Selected Ingredients: ${selectedIngredients.join(', ')}`);

        // 2. Distribute products based on selected ingredients
        const distribution = {};
        const numIngredients = selectedIngredients.length;

        if (numIngredients === 3) {
            // Case: All three ingredients (Pollo, Carne, Pernil)
            // Pollo gets 4, Carne gets 3, Pernil gets 3 for a total of 10
            // We need to scale this proportion based on the actual totalBags
            const proportionUnit = totalBags / 10; // Assuming the example total of 10 bags is the base unit

            if (selectedIngredients.includes('Pollo')) {
                distribution['Pollo'] = Math.round(4 * proportionUnit);
            }
            if (selectedIngredients.includes('Carne')) {
                distribution['Carne'] = Math.round(3 * proportionUnit);
            }
            if (selectedIngredients.includes('Pernil')) {
                distribution['Pernil'] = Math.round(3 * proportionUnit);
            }

            // Adjust to ensure total bags are exactly distributed, accounting for rounding
            let distributedSum = Object.values(distribution).reduce((sum, val) => sum + val, 0);
            let difference = totalBags - distributedSum;
            // Distribute any remaining difference to one of the ingredients (e.g., Pollo)
            if (difference !== 0) {
                if (distribution['Pollo'] !== undefined) {
                    distribution['Pollo'] += difference;
                } else if (distribution['Carne'] !== undefined) {
                    distribution['Carne'] += difference;
                } else if (distribution['Pernil'] !== undefined) {
                    distribution['Pernil'] += difference;
                }
            }


        } else if (numIngredients === 2) {
            // Case: Two ingredients
            // If Pollo and Pernil, they each get 5 for a total of 10
            const bagsPerIngredient = Math.round(totalBags / numIngredients);
            let currentSum = 0;

            selectedIngredients.forEach(ingredient => {
                distribution[ingredient] = bagsPerIngredient;
                currentSum += bagsPerIngredient;
            });

            // Distribute any remaining difference due to rounding (e.g., if totalBags is odd)
            let remaining = totalBags - currentSum;
            if (remaining > 0) {
                 // Add remainder to the first ingredient in the list for simplicity
                distribution[selectedIngredients[0]] += remaining;
            }

        } else if (numIngredients === 1) {
            // Case: Only one ingredient
            distribution[selectedIngredients[0]] = totalBags;
        } else {
            console.warn("Unsupported number of selected ingredients for distribution logic. No distribution applied.");
            return;
        }

        // 3. Log the distribution to the console
        console.log("\n--- Product Distribution ---");
        for (const ingredient in distribution) {
            console.log(`${ingredient}: ${distribution[ingredient]} bags`);
        }
        console.log("----------------------------\n");

        // Here you would typically send this 'distribution' object to your backend
        // or update an order note field in your Shopify cart.
        // Example: shopifyUpdateCartNote(distribution);
    });
});




document.addEventListener('DOMContentLoaded', () => {

    // Define the mapping between ingredient names and their Shopify Variant IDs
    const ingredientVariantMap = {
        'Pollo': '45902440005880',
        'Carne': '45902463664376',
        'Pernil': '45902463697144'
    };

    // Keys for localStorage data
    const localStorageBagsKey = 'bags_to_send';
    const localStorageIngredientsKey = 'order_note_selected_ingredients';
    const localStorageDistributionKey = 'product_distribution';
    const localStorageFrequencyKey = 'selected_frequency_name';
    const localStoragePricePerDayKey = 'calculated_price_per_day';
    const localStorageGramsPerDayKey = 'selected_grams_per_day';

    // Select the "Confirmar" button container
    const confirmButtonContainer = document.querySelector('.atcx-button');

    // =======================================================
    // Product Distribution Logic & Data Saving on Confirm Click
    // =======================================================
    function calculateAndSaveProductDistribution() {
        console.log("Confirm button clicked. Attempting to calculate and save data to localStorage...");

        // --- 1. Retrieve current values directly from the DOM display elements ---
        const gramsValueDisplay = document.querySelector('.cat-gramos-value');
        const frequencyOptionDisplay = document.querySelector('.cat-frequency-option');
        const pricePerDayRegularDisplay = document.querySelector('.price-per-day-cat');
        const bagsToSendDisplay = document.querySelector('.bagsToSend-cat');

        const currentGrams = gramsValueDisplay ? parseInt(gramsValueDisplay.textContent, 10) : 0;
        const currentFrequencyName = frequencyOptionDisplay ? frequencyOptionDisplay.textContent : 'N/A';
        const formattedIntermediatePrice = pricePerDayRegularDisplay ? pricePerDayRegularDisplay.textContent : 'N/A';

        // --- Safely determine finalBagsToSend with source logging ---
        let finalBagsToSend = 0;
        let bagsSource = 'none';

        // Try localStorage first
        const storedBagsStr = localStorage.getItem("Gato Original Bags");
        if (storedBagsStr !== null) {
            const parsedFromStorage = parseInt(storedBagsStr, 10);
            if (!isNaN(parsedFromStorage) && parsedFromStorage >= 0) {
                finalBagsToSend = parsedFromStorage;
                bagsSource = 'localStorage';
            }
        }

        // Fallback to DOM if localStorage was missing or invalid
        if (bagsSource === 'none' && bagsToSendDisplay) {
            const parsedFromDOM = parseInt(bagsToSendDisplay.textContent, 10);
            if (!isNaN(parsedFromDOM) && parsedFromDOM >= 0) {
                finalBagsToSend = parsedFromDOM;
                bagsSource = 'DOM (.bagsToSend-cat)';
            }
        }

        console.log(`✅ Bags value used: ${finalBagsToSend} (source: ${bagsSource})`);

        // --- 2. Retrieve selected ingredients from localStorage ---
        const selectedIngredientsString = localStorage.getItem(localStorageIngredientsKey);
        const selectedIngredients = selectedIngredientsString 
            ? selectedIngredientsString.split(',').map(s => s.trim()).filter(s => s !== '') 
            : [];

        // --- Input Validation ---
        if (finalBagsToSend === 0) {
            console.warn("WARNING: Total bags is 0. Distribution might not be meaningful.");
            localStorage.removeItem(localStorageDistributionKey);
        }
        if (selectedIngredients.length === 0) {
            console.warn("WARNING: No ingredients selected.");
            localStorage.removeItem(localStorageDistributionKey);
        }

        // --- 3. Perform Product Distribution Calculation ---
        const distribution = {};
        const numIngredients = selectedIngredients.length;
        const totalBagsForDistribution = finalBagsToSend;

        if (numIngredients === 3) {
            const proportionUnit = totalBagsForDistribution / 10;
            if (selectedIngredients.includes('Pollo')) {
                distribution['Pollo'] = Math.round(4 * proportionUnit);
            }
            if (selectedIngredients.includes('Carne')) {
                distribution['Carne'] = Math.round(3 * proportionUnit);
            }
            if (selectedIngredients.includes('Pernil')) {
                distribution['Pernil'] = Math.round(3 * proportionUnit);
            }

            let distributedSum = Object.values(distribution).reduce((sum, val) => sum + val, 0);
            let difference = totalBagsForDistribution - distributedSum;
            if (difference !== 0) {
                if (distribution['Pollo'] !== undefined) {
                    distribution['Pollo'] += difference;
                } else if (distribution['Carne'] !== undefined) {
                    distribution['Carne'] += difference;
                } else if (distribution['Pernil'] !== undefined) {
                    distribution['Pernil'] += difference;
                }
            }

        } else if (numIngredients === 2) {
            const baseBagsPerIngredient = totalBagsForDistribution / numIngredients;
            selectedIngredients.forEach(ingredient => {
                distribution[ingredient] = Math.floor(baseBagsPerIngredient);
            });

            let distributedSum = Object.values(distribution).reduce((sum, val) => sum + val, 0);
            let remaining = totalBagsForDistribution - distributedSum;
            for (let i = 0; i < remaining; i++) {
                distribution[selectedIngredients[i % numIngredients]]++;
            }

        } else if (numIngredients === 1) {
            distribution[selectedIngredients[0]] = totalBagsForDistribution;
        } else {
            console.warn("No valid distribution rule for selected ingredients count. Distribution will be empty.");
            localStorage.removeItem(localStorageDistributionKey);
        }

        console.log("\n--- Calculated Product Distribution (for saving) ---");
        for (const ingredient in distribution) {
            console.log(`${ingredient}: ${distribution[ingredient]} bags`);
        }
        console.log("---------------------------------------------------\n");

        // --- 4. Save ALL relevant data to localStorage ---
        localStorage.setItem(localStorageBagsKey, finalBagsToSend.toString());
        localStorage.setItem(localStorageFrequencyKey, currentFrequencyName);
        localStorage.setItem(localStoragePricePerDayKey, formattedIntermediatePrice);
        localStorage.setItem(localStorageGramsPerDayKey, currentGrams.toString());
        localStorage.setItem(localStorageDistributionKey, JSON.stringify(distribution));

        console.log("All data saved to localStorage successfully!");
        console.log("Local Storage State after click:");
        console.log("Bags:", localStorage.getItem(localStorageBagsKey));
        console.log("Frequency:", localStorage.getItem(localStorageFrequencyKey));
        console.log("Price Per Day:", localStorage.getItem(localStoragePricePerDayKey));
        console.log("Grams Per Day:", localStorage.getItem(localStorageGramsPerDayKey));
        console.log("Distribution:", localStorage.getItem(localStorageDistributionKey));
    }

    // --- Attach event listener to the "Confirmar" button ---
    if (confirmButtonContainer) {
        confirmButtonContainer.addEventListener('click', calculateAndSaveProductDistribution);
    } else {
        console.error("CRITICAL ERROR: Element with class 'atcx-button' (Confirm button) not found. Data saving will not work.");
    }
});






document.addEventListener('DOMContentLoaded', function() {
    // Select all checkboxes with the class 'ingredient-selectorx'
    const checkboxes = document.querySelectorAll('.ingredient-selectorx');

    // Iterate over each checkbox and set its 'checked' property to true
    checkboxes.forEach(checkbox => {
        checkbox.checked = true;
    });
});



document.addEventListener('DOMContentLoaded', function() {
  // Get references to your radio buttons
  const cardPaymentRadio = document.getElementById('card-payment');
  const manualPaymentRadio = document.getElementById('manual-payment');

  // --- NEW: Explicitly uncheck the radio buttons on page load ---
  cardPaymentRadio.checked = false;
  manualPaymentRadio.checked = false;
  // --- END NEW ---

  // Function to save the selected value to local storage
  function savePaymentChoice() {
    if (cardPaymentRadio.checked) {
      localStorage.setItem('selectedPaymentOption', cardPaymentRadio.value);
    } else if (manualPaymentRadio.checked) {
      localStorage.setItem('selectedPaymentOption', manualPaymentRadio.value);
    } else {
      // Optional: If neither is checked (e.g., if a user somehow deselects both,
      // which is not standard for radio buttons without custom JS),
      // you might want to remove the stored value.
      // localStorage.removeItem('selectedPaymentOption');
    }
  }

  // Add event listeners to the radio buttons
  // When a user makes a selection, it gets saved to local storage.
  cardPaymentRadio.addEventListener('change', savePaymentChoice);
  manualPaymentRadio.addEventListener('change', savePaymentChoice);

  // The code that used to read from localStorage and check the buttons is intentionally omitted.
  // We only save, we don't load the 'checked' state.
});






document.addEventListener('DOMContentLoaded', () => {

    // Define the mapping between ingredient names and their Shopify Variant IDs
    const ingredientVariantMap = {
        'Pollo': '45902440005880',
        'Carne': '45902463664376',
        'Pernil': '45902463697144'
    };

    // Define the mapping for SELLING PLAN IDs for AUTO (subscription) purchase based on frequency
    const sellingPlanIdMap = {
        '1 Semana': '4672291064',
        '2 Semanas': '4715020536',
        '3 Semanas': '4715053304',
        '4 Semanas': '4715086072',
        '5 Semanas': '4719116536',
        '6 Semanas': '4719149304',
        '7 Semanas': '4719182072',
        '8 Semanas': '4719214840',
        '9 Semanas': '4719247608',
        '10 Semanas': '4719280376',
        '11 Semanas': '4719313144',
        '12 Semanas': '4719345912',
        '13 Semanas': '5010751736'
    };

    // Keys for localStorage data
    const localStorageBagsKey = 'bags_to_send';
    const localStorageIngredientsKey = 'order_note_selected_ingredients';
    const localStorageDistributionKey = 'product_distribution';
    const localStorageFrequencyKey = 'selected_frequency_name'; // e.g., "1 Semana", "2 Semanas"
    const localStoragePricePerDayKey = 'calculated_price_per_day';
    const localStorageGramsPerDayKey = 'selected_grams_per_day';
    const localStoragePaymentOptionKey = 'selectedPaymentOption'; // Key for payment option ('manual' or 'auto')
    const localStorageAddedProductsSummaryKey = 'added_products_summary'; // Key for product summary

    // Select the "Add to Cart" button
    const cartButtonX = document.querySelector('.cart-buttonx');

    // =======================================================
    // Add to Cart Button (cart-buttonx) Logic
    // =======================================================
    if (cartButtonX) {
        cartButtonX.addEventListener('click', function() {
            // Display modal (if you still use it and jQuery is loaded)
            if (typeof jQuery !== 'undefined' && typeof jQuery.fn.show !== 'undefined') {
                $(".modal").show();
            } else {
                console.warn("jQuery or .modal() not found. Skipping modal display.");
            }

            let items = [];
            let checkoutUrl = $("form#cart").attr('action'); // Requires jQuery
            if (checkoutUrl) {
                checkoutUrl = checkoutUrl.replace('/cart/', '/checkout/');
            } else {
                checkoutUrl = '/checkout/'; // Fallback if form#cart action is not found
            }
            console.log("Checkout URL:", checkoutUrl);

            // --- Retrieve all necessary data from localStorage ---
            const storedDistributionString = localStorage.getItem(localStorageDistributionKey);
            const selectedIngredientsString = localStorage.getItem(localStorageIngredientsKey);
            const storedFrequencyName = localStorage.getItem(localStorageFrequencyKey); // e.g., "1 Semana"
            const storedPricePerDay = localStorage.getItem(localStoragePricePerDayKey);
            const storedGramsPerDay = localStorage.getItem(localStorageGramsPerDayKey);
            const selectedPaymentOption = localStorage.getItem(localStoragePaymentOptionKey); // Get the payment option

            // Parse retrieved data, with fallbacks for missing data
            const distribution = storedDistributionString ? JSON.parse(storedDistributionString) : {};
            const allSelectedIngredients = selectedIngredientsString ? selectedIngredientsString.split(',').filter(item => item.trim() !== '') : [];
            const gramsPerDayFormatted = storedGramsPerDay ? `${storedGramsPerDay}gr` : 'N/A';

            // Construct the main order note for Shopify
            let orderNote = '';
            orderNote += `Payment Option: ${selectedPaymentOption || 'N/A'}\n`;
            orderNote += `Grams Per Day: ${gramsPerDayFormatted}\n`;
            orderNote += `Price Per Day: $${storedPricePerDay || 'N/A'}\n`;
            orderNote += `Ingredients: ${allSelectedIngredients.join(', ') || 'None Selected'}\n`;

            // Determine the frequency display for the order note based on payment option
            if (selectedPaymentOption === 'auto') {
                orderNote += `Frequency: ${storedFrequencyName || 'N/A'}\n`;
            } else if (selectedPaymentOption === 'manual') {
                orderNote += `Frecuencia única: ${storedFrequencyName || 'N/A'}\n`; // Changed text for manual
            }


            console.log("Retrieved Distribution:", distribution);
            console.log("Retrieved Selected Ingredients:", allSelectedIngredients);
            console.log("Retrieved Frequency:", storedFrequencyName);
            console.log("Retrieved Price Per Day:", storedPricePerDay);
            console.log("Retrieved Grams Per Day:", storedGramsPerDay);
            console.log("Retrieved Payment Option:", selectedPaymentOption);


            // --- Array to store product summary for localStorage ---
            const addedProductsSummary = [];

            // Prepare items for Shopify Cart API based on the calculated distribution and payment option
            let itemsAddedCount = 0;
            for (const ingredientName in distribution) {
                const quantity = distribution[ingredientName];
                let variantId;
                let sellingPlanId = null;
                let productUrl = `https://www.boneappetit.food/products/testing`; // Base product URL for the store

                // Determine variantId and sellingPlanId based on payment option
                if (selectedPaymentOption === 'manual') {
                    variantId = ingredientVariantMap[ingredientName];
                    productUrl += `?variant=${variantId}`;
                    console.log(`Processing Manual: Ingredient=${ingredientName}, VariantID=${variantId}, Quantity=${quantity}, URL=${productUrl}`);
                } else if (selectedPaymentOption === 'auto') {
                    variantId = ingredientVariantMap[ingredientName]; // Base variant ID is often the same
                    sellingPlanId = sellingPlanIdMap[storedFrequencyName]; // Get the selling plan ID
                    productUrl += `?variant=${variantId}`;
                    if (sellingPlanId) {
                        productUrl += `&selling_plan=${sellingPlanId}`;
                    }
                    console.log(`Processing Auto: Ingredient=${ingredientName}, VariantID=${variantId}, Frequency=${storedFrequencyName}, SellingPlanID=${sellingPlanId}, Quantity=${quantity}, URL=${productUrl}`);
                } else {
                    console.warn(`Unknown payment option: '${selectedPaymentOption}'. Skipping item '${ingredientName}'.`);
                    continue; // Skip this item if payment option is invalid
                }

                if (quantity > 0 && variantId) {
                    let properties = {
                        "Resumen": `${quantity} paquetes de 200gr de ${ingredientName}`,
                    };

                    // Set frequency property name and value based on payment option
                    if (selectedPaymentOption === 'auto' && storedFrequencyName) {
                        properties["Frecuencia"] = storedFrequencyName;
                    } else if (selectedPaymentOption === 'manual') {
                        properties["Frecuencia única"] = storedFrequencyName || 'N/A'; // Changed property name for manual
                    }

                    const item = {
                        id: variantId,
                        quantity: quantity,
                        properties: properties
                    };

                    if (sellingPlanId && selectedPaymentOption === 'auto') {
                        item.selling_plan = sellingPlanId;
                    }

                    items.push(item);
                    itemsAddedCount++;

                    // --- Add product details to the summary array for localStorage ---
                    addedProductsSummary.push({
                        name: ingredientName,
                        quantity: quantity,
                        url: productUrl
                    });

                } else if (!variantId) {
                    console.warn(`Variant ID not found for ingredient: '${ingredientName}'. Item will not be added to cart.`);
                } else if (selectedPaymentOption === 'auto' && !sellingPlanId) {
                    console.warn(`Selling Plan ID not found for frequency: '${storedFrequencyName}'. Item '${ingredientName}' will not be added as subscription.`);
                }
            }

            if (items.length === 0) {
                console.warn("No items generated for cart. Aborting AJAX call.");
                alert("No product configuration found. Please click 'Confirmar' first and ensure a payment option is selected.");
                return; // Stop execution if no items to add
            }

            console.log("Items to add to cart (for Shopify API):", items);
            console.log("Order Note for Shopify:", orderNote);
            console.log("Products Summary for localStorage:", addedProductsSummary);

            // --- Save the product summary to localStorage ---
            localStorage.setItem(localStorageAddedProductsSummaryKey, JSON.stringify(addedProductsSummary));

            // --- AJAX Call to Add Items to Cart ---
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify({ items: items, note: orderNote }),
                contentType: 'application/json',
                dataType: 'json',
                success: function() {
                    console.log("Products successfully added to cart. Redirecting...");
                    window.location.href = checkoutUrl + 'discount=SHIPFREE';
                },
                error: function(xhr, status, error) {
                    console.error("Error adding items to cart:", error);
                    console.error("Status:", status);
                    console.error("Error message:", error);
                    console.error("Response Text:", xhr.responseText);
                    alert('Failed to add products to cart. Please try again. Check console for details.');
                }
            });
        });
    } else {
        console.error("CRITICAL ERROR: Element with class 'cart-buttonx' not found. Add to cart functionality disabled.");
    }
});